import { BN, Program } from '@coral-xyz/anchor'
import * as borsh from '@coral-xyz/borsh'
import { PublicKey } from '@solana/web3.js'
import base58 from 'bs58'
import {
  getReferralAccountPublicKey,
  getUserReferralAccountPublicKey,
  getVaultSystemStatePublicKey,
  Vault,
} from 'hedge-web3'
import ReferralAccount from '../accounts/ReferralAccount'
import { HEDGE_PROGRAM_PUBLICKEY } from './HedgeConstants'

export async function FetchReferralAccountForUser(
  userWalletPublicKey: PublicKey,
  program: Program<Vault>
): Promise<ReferralAccount> {
  const referralAccountPublicKey = await GetReferralAccountPublicKeyForUser(
    userWalletPublicKey,
    program
  )
  const referralAccountData = await program.account.referralAccount.fetch(referralAccountPublicKey)
  return new ReferralAccount(referralAccountData)
}

export async function GetReferralAccountPublicKeyForUser(
  userWalletPublicKey: PublicKey,
  program: Program<Vault>
): Promise<PublicKey> {
  const vaultSystemStatePublicKey = await getVaultSystemStatePublicKey(HEDGE_PROGRAM_PUBLICKEY)

  // Attempt to get the referral account public key for the user
  const userReferralAccountPublicKey = await getUserReferralAccountPublicKey(
    HEDGE_PROGRAM_PUBLICKEY,
    userWalletPublicKey
  )

  // If new referral id, look that up and use it
  // Verify it's not trying to self refer
  const cachedReferralJson = localStorage.getItem('referral')

  // If no new referral id from url, look up what's on users account
  const userReferralAccount = await program.account.userReferralAccount
    .fetch(userReferralAccountPublicKey)
    .catch(() => {})

  if (
    userReferralAccount &&
    userReferralAccount.referrer.toString() === userWalletPublicKey.toString()
  ) {
    return userReferralAccount.referralAccount
  }

  if (cachedReferralJson) {
    console.log('Found a cached referral id:', cachedReferralJson)
    const cachedReferralAccounts = await program.account.referralAccount
      .all([
        {
          memcmp: {
            // Filter for liquidated events
            bytes: base58.encode(encodeU64(cachedReferralJson)),
            offset: 8 + 32 + 16 * 4 + 8 * 5,
          },
        },
      ])
      .catch(() => {})

    if (cachedReferralAccounts && cachedReferralAccounts.length === 1) {
      const refAccount = cachedReferralAccounts[0]
      console.log('Found cached referral accounts public key:', refAccount)

      // Check that this referral account is not the user's own referral account. Can't self refer.
      return refAccount.publicKey
    }
  }

  // if the user has no referral account, return the default (vaultSystemStatePublicKey)
  if (userReferralAccount) {
    if (userReferralAccount.referralId.toString() != '0') {
      return userReferralAccount.referralAccount
    }
  }

  // Else Return the default non-referral account (based on vaultSystemStatePublicKey)

  let referralAccountPublicKey = await getReferralAccountPublicKey(
    HEDGE_PROGRAM_PUBLICKEY,
    vaultSystemStatePublicKey
  )
  return referralAccountPublicKey
}

function encodeU64(num: string): Uint8Array {
  console.log('encodeU64', num)
  const props = [borsh.u64('id')]
  let buffer = Buffer.alloc(8)
  const miniVaultLayout = borsh.struct(props, 'minVaultLayout')
  miniVaultLayout.encode({ id: new BN(num) }, buffer)
  console.log('buffer', buffer)
  return Uint8Array.from(buffer)
}

//18446744073709551616 = 2^64
//13646096770106106000
//9007199254740991
